<template>
    <div>

        <MessageOverlay ref="overlay" />
        <ChangePassword :display="passwordDialog" @cancel="cancelPasswordDialod"/>
        <ChangeMail :display="changeMailDialog" @cancel="cancelChangeMailDialod" @valid="validChangeMailDialod"/>
        <ChangePhoneNumber :display="changePhoneDialog" @cancel="cancelChangePhoneDialod" @valid="validChangePhoneDialod"/>

        <v-row>
            <v-col>
                <v-card max-width="740" class="mx-auto mb-2 rounded-lg">
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-icon size="100">mdi-account-box-outline</v-icon>
                        </v-row>
                        <div class="text-right text-subtitle-2 font-weight-regular mb-1">* {{ $vuetify.lang.t('$vuetify.account.required') }}</div>
                        <v-form ref="formEditAccount" v-model="accountFormValidation" lazy-validation>
                            <v-row class="mb-n10">
                                <v-col cols="1" class="pt-7 mr-n6">
                                    <v-icon>mdi-account-circle</v-icon>
                                </v-col>
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="user.username"
                                        outlined
                                        required
                                        clearable
                                        type="text"
                                        :rules="usernameRules"
                                        :label="$vuetify.lang.t('$vuetify.account.username')+'*'"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mb-n10">
                                <v-col cols="1" class="pt-7 mr-n6">
                                    <v-icon>mdi-email</v-icon>
                                </v-col>
                                <v-col cols="8">
                                    <v-text-field
                                        v-model="originalUser.email"
                                        outlined
                                        required
                                        disabled
                                        type="email"
                                        :label="$vuetify.lang.t('$vuetify.account.email')+'*'"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols=auto class="pt-5">
                                    <v-btn class="gradient-wintech" @click="changeMailDialog = true">
                                        <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-pencil</v-icon>
                                        <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.account.modify') }}</template>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-tooltip :disabled="!!originalUser.phone || !originalUser.haveSMSNotif" top max-width="500">
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-on="on" v-bind="attrs">
                                        <v-row>
                                            <v-col cols="1" class="pt-7 mr-n6">
                                                <v-icon v-if="!originalUser.phone && originalUser.haveSMSNotif" color=red>mdi-phone-off</v-icon>
                                                <v-icon v-else>mdi-phone</v-icon>
                                            </v-col>
                                            <v-col cols="8">
                                                <vue-tel-input-vuetify
                                                    outlined
                                                    clearable
                                                    disabled
                                                    placeholder=""
                                                    appendIcon="$dropdown"
                                                    mode="international"
                                                    type="tel"
                                                    :value="originalUser.phone"
                                                    :valid-characters-only="true"
                                                    :label="$vuetify.lang.t('$vuetify.account.phonenumber')"
                                                ></vue-tel-input-vuetify>
                                            </v-col>
                                            <v-col cols=auto class="pt-5">
                                                <v-btn class="gradient-wintech" @click="changePhoneDialog = true">
                                                    <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-pencil</v-icon>
                                                    <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.account.modify') }}</template>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                                <span>
                                    <div class="text-subtitle-2 font-weight-regular mb-2">
                                        {{ $vuetify.lang.t('$vuetify.account.phonenumberisrequiredtoreceivesms') }}
                                    </div>
                                </span>
                            </v-tooltip>
                        </v-form>
                        <v-card elevation=0 v-if="!!user.orga" class="mt-n10">
                            <v-overlay
                                v-if="!user.orgaValid"
                                class="align-center justify-center overlay"
                            >
                                <v-alert type="error">
                                    {{ $vuetify.lang.t('$vuetify.account.oragnizationCannotBeUsedRentalPeriod1') }}
                                    {{user.orgaName}}
                                    {{ $vuetify.lang.t('$vuetify.account.oragnizationCannotBeUsedRentalPeriod2') }}
                                </v-alert>
                            </v-overlay>
                            <v-row align="center" class=""> 
                                <v-col v-if="$vuetify.breakpoint.smAndUp" cols="auto" class="pt-1 pr-0">
                                    <v-icon>
                                        mdi-bell-cog
                                    </v-icon>
                                </v-col>
                                <v-col class="pt-1">
                                    <fieldset style="border-width: 1px; border-color: rgba(0, 0, 0, 0.38); border-style: solid; border-radius: 4px; font-size: 13px;">
                                        <v-row justify="space-around" class="mt-2 mb-10">
                                          <h2>{{ $vuetify.lang.t('$vuetify.account.organization') }}"{{user.orgaName}}"</h2>
                                          <h2>{{ $vuetify.lang.t('$vuetify.account.role') }}"{{user.role}}"</h2>
                                        </v-row>
                                        <legend class="ml-2 px-1" style="letter-spacing: normal">
                                            <v-tooltip bottom max-width="500">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <div v-on="on" v-bind="attrs">
                                                        Notifications
                                                        <v-icon size="18" color="rgba(62,143,197,1)">
                                                            mdi-information
                                                        </v-icon>
                                                    </div>
                                                </template>
                                                <span>
                                                    <div class="text-subtitle-2 font-weight-regular mb-2">
                                                        <strong>NB:</strong> {{ $vuetify.lang.t('$vuetify.account.nb1') }}<br>{{ $vuetify.lang.t('$vuetify.account.nb2') }}
                                                    </div>
                                                </span>
                                            </v-tooltip>
                                        </legend>
                                        <v-simple-table fixed-header height="245"> 
                                            
                                            <template v-slot:default>
                                                
                                            
                                                <thead>
                                                    <tr>
                                                        <th class="px-1 px-sm-2 text-center">
                                                            <v-icon>mdi-bell</v-icon>
                                                            <div>{{ $vuetify.lang.t('$vuetify.account.event') }}</div>
                                                        </th>
                                                        <th class="px-1 px-sm-2 text-center">
                                                            <v-icon>mdi-email</v-icon>
                                                            <div>{{ $vuetify.lang.t('$vuetify.account.sendmail') }}</div>
                                                        </th>
                                                        <th class="px-1 px-sm-2 text-center">
                                                            <v-icon>mdi-cellphone-message</v-icon>
                                                            <div>{{ $vuetify.lang.t('$vuetify.account.sendSMS') }}<sup>(1)</sup></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(event, i) in events" :key="i">
                                                        <td class="px-1 px-sm-2">
                                                            {{ $vuetify.lang.current=='en' ? event.prettyNameEN : event.prettyNameFR }}
                                                            <sup v-if="event.adminDefaultEnabled === 1">(2)</sup>
                                                            <sup v-if="event.name==='ALARM' || event.name==='INTRUSION'">(3)</sup>
                                                        </td>
                                                        <td class="px-1 px-sm-2 text-center">
                                                            <v-switch
                                                                v-if="event.supervisionMailAvailable===1"
                                                                v-model="event.boolMail"
                                                                dense
                                                                inset
                                                                :disabled="(user.role === 'ADMINISTRATION' && event.adminDefaultEnabled === 1) || user.role === 'CONSULTATION'"
                                                                hide-details
                                                                class="pt-0 mt-0 justify-center d-inline-block"
                                                            ></v-switch>
                                                        </td>
                                                        <td class="px-1 px-sm-2 text-center">
                                                            <v-switch
                                                                v-if="event.supervisionSMSAvailable===1 && twilioAccount"
                                                                v-model="event.boolSMS"
                                                                dense
                                                                inset
                                                                :disabled="user.role === 'CONSULTATION'"
                                                                hide-details
                                                                class="pt-0 mt-0 justify-center d-inline-block"
                                                            ></v-switch>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </fieldset>
                                </v-col>
                            </v-row>
                        </v-card>
                        <div class="ml-sm-9 mt-5" v-if="!!user.orga">
                            <div class="text-subtitle-2 font-weight-regular">(1) {{ $vuetify.lang.t('$vuetify.account.warning') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(2) {{ $vuetify.lang.t('$vuetify.account.info') }}</div>
                            <div class="text-subtitle-2 font-weight-regular">(3) {{ $vuetify.lang.t('$vuetify.account.notifutc') }}</div>
                        </div>
                    </v-card-text>
                    <v-card-actions class="pa-4 pt-0">
                        <v-btn
                            class="gradient-wintech"
                            @click="passwordDialog = true"
                        >
                            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-key-variant</v-icon>
                            <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.account.password') }}</template>
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            :disabled="!accountValuesChanged || saveAccountButtonLoading || !accountFormValidation "
                            :loading="saveAccountButtonLoading"
                            :class="!accountValuesChanged || saveAccountButtonLoading || !accountFormValidation  ? '' : 'gradient-wintech'"
                            @click="saveAccount"
                        >
                            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-content-save</v-icon>
                            <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.account.save') }}</template>
                        </v-btn>
                        <v-btn
                            :disabled="!accountValuesChanged"
                            color="error"
                            @click="resetUserForm"
                        >
                            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-backup-restore</v-icon>
                            <template v-if="$vuetify.breakpoint.smAndUp">{{ $vuetify.lang.t('$vuetify.account.reset') }}</template>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1 !important;
    }
</style>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import MessageOverlay from './Overlay/MessageOverlay.vue';
import ChangePassword from './Confidentiality/ChangePassword.vue';
import ChangeMail from './Confidentiality/ChangeMail.vue';
import ChangePhoneNumber from './Confidentiality/ChangePhoneNumber.vue';
var cloneDeep = require('lodash.clonedeep');

export default {
    name: "Account",
    components: {MessageOverlay, ChangePassword, ChangeMail, ChangePhoneNumber},
    data() {
        return {
            user: Object.assign({}, this.originalUser),
            
            events:[],
            eventsSave:[],
            usernameRules: [
                v => !!v ||this.$vuetify.lang.t('$vuetify.account.usernameisrequired'),
            ],
            
            twilioAccount: false,
            saveAccountButtonLoading: false,

            accountFormValidation: true,
            passwordDialog: false,
            changeMailDialog: false,
            changePhoneDialog: false,
            phoneRules: [
                value => !!value || 'Required.',
            ],
            
        };
        
    },

    computed: {
        ...mapGetters({ originalUser: "StateUser"}),

        isConsultation() {
            return this.originalUser.role === 'CONSULTATION'
        },
        isAdministration() {
            return this.originalUser.role === 'ADMINISTRATION'
        },

        accountValuesChanged() {
            return this.user.username !== this.originalUser.username ||
                    this.events.some((event, index) => (+event.boolMail !== +this.eventsSave[index].boolMail) || (+event.boolSMS !== +this.eventsSave[index].boolSMS))
        },
    },

    async mounted() {
        this.user = Object.assign({}, this.originalUser);
        this.getEvents();
    },

    methods: {
        ...mapActions(["SetUser"]),
        async saveAccount() {
            this.saveAccountButtonLoading = true;
            if (this.$refs.formEditAccount.validate()) {
                let data = Object.assign({}, this.originalUser);
                data.username = this.user.username;
                data.notifications = this.events.map(({ idEvent, boolMail, boolSMS }) => ({ idEvent, boolMail, boolSMS }));
                try {
                    const res = await axios.put('users/user', data);
                    if (res.status == 200) {
                        data.token = res.data.token;
                        data.haveSMSNotif = res.data.haveSMSNotif;
                        await this.SetUser(data);
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.account.changesOK'));
                        this.eventsSave = cloneDeep(this.events);
                    }
                } catch(error) {
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
            this.saveAccountButtonLoading = false;
        },

        resetUserForm() {
            this.user.username = this.originalUser.username;
            this.events = cloneDeep(this.eventsSave);
        },

        async getEvents() {
            if(!this.user.orga)
                return;
            try {
                const res = await axios.get('users/event/'+this.user.id+'/'+this.user.orga);
                if (res.status === 200) {
                    this.events = res.data.events;
                    this.twilioAccount = res.data.twilioAccount;
                    this.eventsSave = cloneDeep(this.events);
                }
            } catch (error) {
                this.$refs.overlay.showOverlay("error", error);
            }
        },
        cancelPasswordDialod(){
            this.passwordDialog=false;
        },
        cancelChangeMailDialod(){
            this.changeMailDialog=false;
        },
        cancelChangePhoneDialod(){
            this.changePhoneDialog=false;
        },
        validChangeMailDialod(){
            this.changeMailDialog=false;
            this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.account.emailChangesOK'));
        },
        validChangePhoneDialod(){
            this.changePhoneDialog=false;
            this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.account.phoneChangesOK'));
        },
    },
};
</script>
<style scoped>
.v-input--switch >>> .v-input--selection-controls__input {
    margin-right: -8px;
}
</style>